import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="book-cover-designer"
//
// Lets an admin pick a generated book-cover theme on the book edit form and
// shows a live preview. The chosen gradient + text color are written into
// hidden fields (book[background], book[text_color]); blank values mean
// "let the system pick a default".
//
//   <div data-controller="book-cover-designer"
//        data-book-cover-designer-default-background-value="linear-gradient(...)">
//     <div data-book-cover-designer-target="preview" style="background: ...">…</div>
//     <button data-action="book-cover-designer#select"
//             data-background="linear-gradient(...)" data-text-color="#fff">…</button>
//     <button data-action="book-cover-designer#selectDefault"
//             data-book-cover-designer-target="defaultSwatch">…</button>
//     <input type="hidden" data-book-cover-designer-target="background">
//     <input type="hidden" data-book-cover-designer-target="textColor">
//   </div>
export default class extends Controller {
  static targets = ["preview", "background", "textColor", "defaultSwatch"]
  static values = { defaultBackground: String }

  connect() {
    this.highlight(this.backgroundTarget.value)
  }

  select(event) {
    const button = event.currentTarget
    this.apply(button.dataset.background, button.dataset.textColor || "#ffffff")
    this.highlight(button.dataset.background)
  }

  selectDefault() {
    this.apply("", "")
    this.highlight("")
  }

  apply(background, textColor) {
    this.backgroundTarget.value = background
    this.textColorTarget.value = textColor
    if (this.hasPreviewTarget) {
      this.previewTarget.style.background = background || this.defaultBackgroundValue
      this.previewTarget.style.color = textColor || "#ffffff"
    }
  }

  highlight(background) {
    this.element.querySelectorAll(".book-cover-theme-swatch").forEach((el) => {
      el.classList.remove("is-selected")
    })

    let match = null
    if (background) {
      match = this.element.querySelector(
        `.book-cover-theme-swatch[data-background="${background}"]`
      )
    }

    if (match) {
      match.classList.add("is-selected")
    } else if (this.hasDefaultSwatchTarget) {
      this.defaultSwatchTarget.classList.add("is-selected")
    }
  }
}
